import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { Router } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { install } from 'resize-observer'

import reportWebVitals from './reportWebVitals'
import history from './history'
import './index.css'
import App from './App'
import configureStore from './state/store'
import { getAsyncInjectors } from './utils/asyncInjectors'

const initialState = {}
const store = configureStore(initialState)
const { injectReducer, injectSaga } = getAsyncInjectors(store)

if (typeof window !== 'undefined' && !window.ResizeObserver) {
  install()
}

const container = document.getElementById('root')
const root = createRoot(container)

root.render(
  <Provider store={store}>
    <Router history={history}>
      <HelmetProvider>
        <App injectReducer={injectReducer} injectSaga={injectSaga} />
      </HelmetProvider>
    </Router>
  </Provider>,
)
reportWebVitals()
